import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
    ClientProduct,
    ProductType,
} from '../components/client-product-mapping/client-product-mapping-data-model';

@Injectable({
    providedIn: 'root',
})
export class ClientProductService {
    private serverUrl = 'https://' + window.location.host;
    private version = '0.5';
    private _url = (this.serverUrl + '/api/v{version}/clientproduct/').replace(
        '{version}',
        this.version
    );

    constructor(private http: HttpClient) {}

    submitChanges(changedOrAddedProducts) {
        return new Observable((subscriber) => {
            this.http.post<any>(this._url + 'SubmitChanges', changedOrAddedProducts).subscribe(
                () => {
                    subscriber.next(true);
                },
                (response) => {
                    subscriber.error(response);
                }
            );
        });
    }

    getClientProducts(): Observable<ClientProduct[]> {
        return this.http.get<ClientProduct[]>(this._url + 'GetClientProducts/');
    }

    getProductTypes(): Observable<ProductType[]> {
        return this.http.get<ProductType[]>(this._url + 'GetProductTypes/');
    }
}
